import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {
      /* TODO: Replace last-updated date for every published change */
    }
    <p>{`These npm Open Source terms of use (these `}<em parentName="p">{`Terms`}</em>{`) govern access to
and use of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com"
      }}>{`https://www.npmjs.com`}</a>{` (the `}<em parentName="p">{`Website`}</em>{`) as well as the
"npm Public Registry" at `}<a parentName="p" {...{
        "href": "https://registry.npmjs.org"
      }}>{`https://registry.npmjs.org`}</a>{` (the `}<em parentName="p">{`Public
Registry`}</em>{`). npm, Inc. (`}<em parentName="p">{`npm`}</em>{`) operates each of those
services. These terms refer to all of them together as `}<em parentName="p">{`npm Open
Source`}</em>{`.`}</p>
    <p>{`npm last updated these npm Open Source Terms on
March 10, 2022.
You can review prior versions at
`}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/open-source-terms.mdx"
      }}>{`https://github.com/npm/documentation/blob/main/content/policies/open-source-terms.mdx`}</a>{`.`}</p>
    <h2>{`Important Terms`}</h2>
    <p><strong parentName="p"><em parentName="strong">{`These Terms include a number of important provisions that affect your
rights and responsibilities, such as the disclaimers in "Disclaimers",
limits on npm's liability to you in "Limits on Liability", and an
agreement to arbitrate disputes individually in "Arbitration".`}</em></strong></p>
    <h2>{`Other Terms`}</h2>
    <p>{`npm offers additional, paid services (`}<em parentName="p">{`Paid Services`}</em>{`) that are subject
to additional terms:`}</p>
    <ul>
      <li parentName="ul">{`Additional terms for npm Paid Services are available at
`}<a parentName="li" {...{
          "href": "/policies/private-terms"
        }}>{`https://docs.npmjs.com/policies/private-terms`}</a>{`.`}</li>
    </ul>
    <p>{`npm Open Source and any Paid Services you may agree to use are together
called `}<em parentName="p">{`npm Services`}</em>{` throughout these Terms.`}</p>
    <h2>{`Legal Agreement`}</h2>
    <p>{`You may only access or use npm Services by agreeing to these Terms.
If npm adds any additional functionality to npm Services, you must
agree to these Terms to use that new functionality, too. You show your agreement
with npm on these Terms by creating a user account (your `}<em parentName="p">{`Account`}</em>{`)
or by accessing or using npm Services without creating an account.
The agreement between you and npm is a legally binding contract (this
`}<em parentName="p">{`Agreement`}</em>{`).`}</p>
    <h2>{`Changes`}</h2>
    <p>{`npm may change these Terms and the additional terms for Paid Services
in the future. npm will post changes on the Website with a new "last
updated" date. If you have an Account, npm will notify you of changes
by email to the address provided for your Account, by a message on the
Website, or both. If you do not have an account, npm may notify you of
changes by a general announcement via the Website, but it is up to you
to check for changes to these Terms. After receiving notice of changes
to these Terms, you must accept those changes to continue using npm
Services. You accept changes to these Terms by continuing to use npm
Services. npm may change, suspend, or discontinue npm Services at any
time without notice or liability to you.`}</p>
    <h2>{`npm Policies`}</h2>
    <p>{`npm respects your privacy and limits use and sharing of information
about you collected by npm Services. The privacy policy at
`}<a parentName="p" {...{
        "href": "/policies/privacy"
      }}>{`https://docs.npmjs.com/policies/privacy`}</a>{`(the `}<em parentName="p">{`Privacy Policy`}</em>{`)
describes these policies. npm will abide by the Privacy Policy and honor
the privacy settings that you choose via npm Services.`}</p>
    <p>{`npm respects the exclusive rights of copyright holders and responds
to notifications about alleged infringement via npm Services per
the copyright policy at `}<a parentName="p" {...{
        "href": "/policies/dmca"
      }}>{`https://docs.npmjs.com/dmca`}</a>{` (the
`}<em parentName="p">{`Copyright Policy`}</em>{`).`}</p>
    <p>{`npm resolves disputes about package names, user names, and organization
names in the Public Registry per the policy at
`}<a parentName="p" {...{
        "href": "/policies/disputes"
      }}>{`https://docs.npmjs.com/disputes`}</a>{` (`}<em parentName="p">{`Dispute Policy`}</em>{`). This
includes "package squatting".`}</p>
    <p>{`Use of all npm Services is governed by the code of conduct at
`}<a parentName="p" {...{
        "href": "/policies/conduct"
      }}>{`https://docs.npmjs.com/conduct`}</a>{` (`}<em parentName="p">{`Code of Conduct`}</em>{`).`}</p>
    <p>{`npm permits use of npm trademarks per the policy at
`}<a parentName="p" {...{
        "href": "/policies/trademark"
      }}>{`https://docs.npmjs.com/trademark`}</a>{`.`}</p>
    <h2>{`Use of npm Open Source`}</h2>
    <p>{`Subject to these Terms, npm grants you permission to use npm Open
Source. That permission is not exclusive to you, and you cannot transfer
it to anyone else.`}</p>
    <p>{`Your permission to use npm Open Source entitles you to do the following:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`You may search for, download, publish, and manage packages of
computer code (`}<em parentName="p">{`Packages`}</em>{`) in the Public Registry, and otherwise
interact with the Public Registry, via the command-line tool
published by npm at `}<a parentName="p" {...{
            "href": "https://www.github.com/npm/cli"
          }}>{`https://www.github.com/npm/cli`}</a>{` (the `}<em parentName="p">{`CLI`}</em>{`).`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may search for, download, publish, and manage Packages using
software other than CLI via application programming interfaces that
npm publicly documents or makes available for public use (`}<em parentName="p">{`Public
APIs`}</em>{`).`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may search for and manage Packages in the Public Registry, and
otherwise interact with the Public Registry, via the Website.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may update and manage your Account via the Website.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may visit, create an account for, and participate in,
discussions on npm.community.`}</p>
      </li>
    </ol>
    <h2>{`Conditions`}</h2>
    <p>{`Your permission to use npm Open Source, as well as any permission you
may have to use Paid Services, are subject to the following conditions:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`You must be at least 13 years of age to use npm Services.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may not use npm Services after npm says you may not, such as by
disabling your Account.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You must use npm Services only in accordance with "Acceptable Use".`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may access and use data about the security of Packages, such
as vulnerability reports, audit status reports, and supplementary
security documentation, only for your own personal or internal
business purposes. You may `}<em parentName="p">{`not`}</em>{` provide others access to, copies
of, or use of npm data about the security of Packages, directly
or as part of other products or services.`}</p>
      </li>
    </ol>
    <h2>{`Acceptable Use`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`You will abide by the
`}<a parentName="p" {...{
            "href": "/policies/conduct"
          }}>{`Code of Conduct`}</a>{` and the
`}<a parentName="p" {...{
            "href": "/policies/disputes"
          }}>{`Dispute Policy`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not submit material to npm as a package or in any other
form that violates npm's `}<em parentName="p">{`Acceptable Content`}</em>{`, described below.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not disclose information that you do not have the right to
disclose, such as confidential information of others.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not copy or share any personally identifiable information of
any other person without their specific permission.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not violate any applicable law.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not use or attempt to use another person's Account without
their specific permission.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not buy, sell, or otherwise trade in user names,
organization names, names for `}<em parentName="p">{`Packages`}</em>{`, or any other names
reserved on `}<em parentName="p">{`npm Services`}</em>{`, for money or other compensation.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not use `}<em parentName="p">{`npm Services`}</em>{`' ability to send e-mail to send
advertisements, chain letters, or other solicitations.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not automate access to, use, or monitor the Website, such
as with a web crawler, browser plug-in or add-on, or other computer
program that is not a web browser. You may replicate data from the
Public Registry using the Public APIs per this Agreement.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not use npm Services to send email to distribution lists,
newsgroups, or group mail aliases.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not falsely imply that you are affiliated with or endorsed
by npm.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not operate illegal schemes, such as pyramid schemes, via
npm Services.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not deep-hyperlink to images or other non-hypertext content
served by npm Services.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not remove any marking indicating proprietary ownership
from any material got via npm Services.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not display any portion of the Website via an HTML IFRAME.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not disable, avoid, or circumvent any security or access
restrictions of npm Services, or access parts of npm Services not
intended for access by you.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not strain infrastructure of npm Services with an
unreasonable volume of requests, or requests designed to impose an
unreasonable load on IT systems underlying npm Services. This rule
is intentionally loose, to give npm the flexibility it needs to keep
npm Services working for the user community as a whole. But to draw
one clear line, under no circumstances are five million requests to
npm Services in a single month-long period by any single individual,
organization, or group of affiliated companies remotely reasonable. If
you have a special need to make lots and lots of requests, `}<a parentName="p" {...{
            "href": "mailto:sales@npmjs.com"
          }}>{`our
sales team`}</a>{` can help.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will not encourage or assist any other person in violation of
"Acceptable Use".`}</p>
      </li>
    </ol>
    <h2>{`Acceptable Content`}</h2>
    <p>{`Administrators at npm reserve the right to delete content hosted on
the npm Services that they deem unacceptable. Unacceptable content
can take the form of a package, a README file, a user or organization
name, or any other content submitted to npm Services. A few examples
of unacceptable content:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Content that is illegal, offensive, or otherwise harmful. This includes
content that is harassing, inappropriate, or abusive.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Content in violation of law, infringing the intellectual property
rights of others, violating the privacy or other rights of others,
or in violation of any agreement with a third party. This includes
code that violates a public license for others' work.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Content containing malicious computer code, such as computer viruses,
computer worms, rootkits, back doors, or spyware. This includes content
submitted for research purposes. Tools designed and documented explicitly to
assist in security research are acceptable, but exploits and malware that
use the npm registry as a deployment or delivery vector are not.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Packages that are not functionally compatible with the npm
command-line client. For example, a "package" cannot simply be
a PNG or JPEG image, a movie file, or a text document uploaded
directly to the registry. Using the Public Registry as a general purpose database is not allowed.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Content that exists only to "reserve" a name, whether a package name,
user name, or organization name. The
`}<a parentName="p" {...{
            "href": "/policies/disputes"
          }}>{`Dispute Policy`}</a>{` governs
how npm handles such cases of "squatting".`}</p>
      </li>
    </ol>
    <p>{`To find out how to report violations of Acceptable Content, refer to the
`}<a parentName="p" {...{
        "href": "/policies/conduct"
      }}>{`Code of Conduct`}</a>{`.`}</p>
    <h2>{`Commercial Content`}</h2>
    <p>{`The npm Public Registry is about Packages.  All manner of
useful Packages are welcome, from hobby projects to
competitive products, enterprise infrastructure and tooling
to the latest fun hack or work of software art.`}</p>
    <p>{`At the same time, the npm Public Registry, the Website, and
important conventions like `}<inlineCode parentName="p">{`README`}</inlineCode>{` go beyond just code.
Developers use all of those channels to communicate more
broadly about code, who is developing it, why, and how.`}</p>
    <p>{`That communication is important, and welcome, so long as it
respects that the npm Public Registry, the website, and npm
Open Source more generally remain neutral.  You are free to
use npm Open Source for commercial projects, to advance your
career, and for other business purposes.  But you may not
leverage content or system conventions to make the npm
Public Registry, Website, or CLI put business before code.`}</p>
    <p>{`These kinds of commercial content are generally acceptable
in `}<inlineCode parentName="p">{`README`}</inlineCode>{` files and other documentation:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Credits, acknowledgments, attributions, and other
recognitions of contributions to Packages.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Information on how to pay, donate to, and otherwise
support Package development, Package developers, and
Package steward organizations.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Logos from, and links to, organizations developing,
stewarding, or sponsoring Package development.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Information on paid products and services related to
Packages, such as enhanced versions, add-ons, commercial
license terms, training, integration, or support.`}</p>
      </li>
    </ol>
    <p>{`These kinds of commercial content generally `}<em parentName="p">{`aren't`}</em>{`
acceptable:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><inlineCode parentName="p">{`README`}</inlineCode>{`, `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, or other content displaying
advertisements.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Packages that display ads at runtime, on installation,
or at other stages of the software development
lifecycle, such as via `}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/misc/scripts"
          }}>{`npm
scripts`}</a>{`.  Packages
with code that can be used to display ads are fine.
Packages that themselves display ads are not.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Packages that function primarily as ads, with only
placeholder or negligible code, data, and other
technical content.`}</p>
      </li>
    </ol>
    <p>{`These examples are just examples.  npm will continue to
apply its judgment when deciding what content is acceptable.
npm will continue to expect you to apply your own judgment
when choosing what you share and how. `}</p>
    <h2>{`Enforcement of Acceptable Use`}</h2>
    <p>{`npm may investigate and prosecute violations of this Agreement to the
fullest legal extent. npm may notify and cooperate with law enforcement
authorities in prosecuting violations of this Agreement.`}</p>
    <h2>{`Your Account`}</h2>
    <p>{`You must create and log into an Account to access features of some npm
Services, including npm Open Source.`}</p>
    <p>{`To create an Account, you must provide certain information about
yourself, as required by the account creation form on the Website or the
CLI. If you create an Account, you will provide, at a minimum, a valid
email address. You will keep that email address up-to-date. You will
not impersonate any other individual. You may delete your Account at any
time by `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`contacting support`}</a>{`.`}</p>
    <p>{`You will be responsible for all action taken using your account, whether
authorized by you or not, until you either close your account or give
npm notice that the security of your Account has been compromised.
You will notify npm immediately if you suspect the security of your
Account has been compromised. You will select a secure password for your
Account. You will keep your password secret.`}</p>
    <p>{`npm may restrict, suspend, or terminate your Account according to the
Copyright Policy, if npm reasonably believes that you are in breach of
these Terms, or if npm reasonably believes that you have misused npm
Services.`}</p>
    <h2>{`Your Content`}</h2>
    <p>{`Nothing in this Agreement gives npm any ownership rights in intellectual
property that you share with npm Services, such as your Account
information or any Packages you share with npm Services (`}<em parentName="p">{`Your
Content`}</em>{`). Nothing in this Agreement gives you any ownership rights in
npm intellectual property provided via npm Services, like software,
documentation, trademarks, service marks, logotypes, or other
distinguishing graphics.`}</p>
    <p>{`Between you and npm, you remain solely responsible for Your Content. You
will not wrongly imply that Your Content is sponsored or approved by
npm. npm will not be obligated to store, maintain, or provide copies of
your content, except per the Privacy Policy.`}</p>
    <p>{`npm may remove Your Content from npm Services without notice if npm
suspects Your Content was submitted or used in violation of "Acceptable
Use", as well as per the Copyright Policy.`}</p>
    <p>{`Your Content belongs to you. You decide whether and how to license it.
But at a minimum, you license npm to provide Your Content to users
of npm Services when you share Your Content. That special license
allows npm to copy, publish, and analyze Your Content, and to share
its analyses with others. npm may run computer code in Your Content to
analyze it, but npm's special license alone does not give npm the right
to run code for its functionality in npm products or services.`}</p>
    <p>{`When Your Content is removed from npm Services,
whether by you or npm, npm's special license ends when the last copy
disappears from npm's backups, caches, and other systems. Other
licenses, such as open source licenses, may continue after Your Content
is removed. Those licenses may give others, or npm itself, the right to
share Your Content with npm Services again.`}</p>
    <p>{`Others who receive Your Content via npm Services may violate the terms
on which you license Your Content. You agree that npm will not be liable
to you for those violations or their consequences.`}</p>
    <h2>{`Feedback`}</h2>
    <p>{`npm welcomes your feedback and suggestions for npm Services. You agree
that npm will be free to act on feedback and suggestions you provide
without further notice, consent, or payment. You will not submit
feedback or suggestions that you consider confidential or proprietary.`}</p>
    <h2>{`Indemnity`}</h2>
    <p>{`You will indemnify npm, its officers, directors, employees,
representatives, and agents, and hold them harmless for, all liability,
expenses, damages, and costs from any third-party claims, demands,
lawsuits, or other proceedings alleging that Your Content, your use
of npm Services, or both, violate the intellectual property right of
a third party, this Agreement, or applicable law. You will not settle
any such proceeding without the prior written consent of npm. npm will
notify you of any such proceeding it becomes aware of.`}</p>
    <h2>{`Disclaimers`}</h2>
    <p><strong parentName="p"><em parentName="strong">{`Use of npm Services is at your sole risk. npm Services are provided
on an "as is" and "as available" basis. npm expressly disclaims all
warranties of any kind, whether express, implied, or statutory,
including implied warranties of title, noninfringement, merchantability,
and fitness for a particular purpose.`}</em></strong></p>
    <p><strong parentName="p"><em parentName="strong">{`npm makes no warranty that npm Services will meet your requirements,
operate in an uninterrupted, timely, secure, or error-free manner, or
that errors in npm Services will be corrected.`}</em></strong></p>
    <p><strong parentName="p"><em parentName="strong">{`You receive material via npm Services at your sole risk. You will be
solely responsible for any damage to your computer system and network,
as well as any data loss that may result from use of npm Services or
material received via npm Services.`}</em></strong></p>
    <p>{`npm Services may provide information and software that is inaccurate,
incomplete, misleading, illegal, offensive, or otherwise harmful. npm
may, but does not promise to, review content provided by npm Services.`}</p>
    <p>{`npm Services provide information about ownership and licensing of
Packages, as provided by those Packages' publishers. That information
may be wrong. npm cannot and does not provide legal advice.`}</p>
    <h3>{`Third-Party Services`}</h3>
    <p>{`npm Services may hyperlink to and integrate with third-party
applications, websites, and other services. You decide whether and how
to use and interact with such services. npm does not make any warranty
regarding such services or content they may provide, and will not be
liable to you for any damages related to such services. Use of such
third-party services may be governed by other terms and privacy notices
that are not part of this Agreement and are not controlled by npm.`}</p>
    <h2>{`Limits on Liability`}</h2>
    <p><strong parentName="p"><em parentName="strong">{`Neither npm nor any third-party service provider used by npm to
provide npm Services will, under any circumstances, be liable to you
for any indirect, incidental, consequential, special, or exemplary
damages related to your use of npm Services or this Agreement, whether
based on breach of contract, breach of warranty, tort (including
negligence, product liability, or otherwise), or any other pecuniary
loss, and whether or not npm has been advised of the possibility of such
damages.`}</em></strong></p>
    <p><strong parentName="p"><em parentName="strong">{`To the maximum extent permitted by law, npm's liability to you for
any damages related to this Agreement, for any one or more causes and
regardless of the form of action, will not exceed $50.`}</em></strong></p>
    <p>{`Some jurisdictions do not allow exclusion of certain warranties or
limits on liability for incidental or consequential damages. Some of
"Disclaimers" and "Limits on Liability" may not apply to you.`}</p>
    <h2>{`Termination`}</h2>
    <p>{`Either you or npm may terminate this Agreement at any time with notice
to the other.`}</p>
    <p>{`On termination of this Agreement, your permission to use npm Open
Source, as well any permission you may have to access Paid Services
under additional terms, also terminate.`}</p>
    <p>{`The following provisions survive termination of this Agreement: "Your
Content", "Feedback", "Indemnity", "Disclaimers", "Limits on Liability",
and "General Terms". Users of npm Services may continue to copy and
share Your Content after termination of this Agreement.`}</p>
    <h2>{`Payment Terms`}</h2>
    <p>{`There is no charge for use of npm Open Source. If you use Paid Services
from npm, our Paid Services Terms at `}<a parentName="p" {...{
        "href": "/policies/private-terms"
      }}>{`https://docs.npmjs.com/policies/private-terms`}</a>{`
apply.`}</p>
    <h2>{`General Terms`}</h2>
    <p>{`If a provision of this Agreement is unenforceable as written, but could
be changed to make it enforceable, that provision should be modified to
the minimum extent necessary to make it enforceable. Otherwise, that
provision should be removed.`}</p>
    <p>{`You may not assign this Agreement. npm may assign this Agreement to any
affiliate of npm, any third party that obtains control of npm, or any
third party that purchases assets of npm relating to npm Services. Any
purported assignment of rights in breach of this provision is void.`}</p>
    <p>{`Neither the exercise of any right under this Agreement, nor waiver of
any breach of this Agreement, waives any other breach of this Agreement.`}</p>
    <p>{`This Agreement, together with the additional terms for Paid Services
and npm software that you and npm agree to, embody all the terms of
agreement between you and npm about npm Services. This Agreement
supersedes any other agreements about npm Services, written or not.`}</p>
    <h2>{`Disputes`}</h2>
    <p>{`The law of the State of California will govern any dispute, including
any legal proceedings, relating to this Agreement or your use of npm
Services (a `}<em parentName="p">{`Dispute`}</em>{`).`}</p>
    <p>{`You and npm will seek injunctions related to this agreement only in
state or federal court in San Francisco, California. Neither you nor npm
will object to jurisdiction, forum, or venue in those courts.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`Other than to seek an injunction, you and npm will resolve any
Dispute by binding American Arbitration Association arbitration.
Arbitration will follow the AAA's Commercial Arbitration Rules and
Supplementary Procedures for Consumer Related Disputes. Arbitration will
happen in San Francisco, California. You will settle any Dispute as an
individual, and not as part of a class action or other representative
proceeding, whether as the plaintiff or a class member. No arbitrator
will consolidate any Dispute with any another arbitration without npm's
permission.`}</em></strong></p>
    <p>{`Any arbitration award will include costs of the arbitration, reasonable
attorneys' fees, and reasonable costs for witnesses. You or npm can
enter arbitration awards in any court with jurisdiction.`}</p>
    <h2>{`Notices and Questions`}</h2>
    <p>{`You may send notice to npm and questions about the terms governing npm
products and services to `}<a parentName="p" {...{
        "href": "mailto:legal@npmjs.com"
      }}>{`legal@npmjs.com`}</a>{` or
by mail to:`}</p>
    <p>{`GitHub, Inc`}<br parentName="p"></br>{`
`}{`Attn: npm Legal Department`}<br parentName="p"></br>{`
`}{`88 Colin P Kelly Jr St`}<br parentName="p"></br>{`
`}{`San Francisco, CA. 94107`}</p>
    <p>{`npm may send you notice using the email address you provide for your
Account or by posting a message to the homepage or your Account page
on the Website.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      